import { RAMBO_LIST_FAIL, RAMBO_LIST_REQUEST, RAMBO_LIST_SUCCESS, RAMBO_LIST_UPDATE } from "../constats/rambo.constant";

export const ramboListReducer = (state={}, action) => {
    switch (action.type) {
        case RAMBO_LIST_REQUEST:
            return {
                loading: true
            };
        case RAMBO_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case RAMBO_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        case RAMBO_LIST_UPDATE:
            return {
                ...state,
                data: {
                    ...state.data,
                    data: state.data.data.map(element =>
                        element.id === action.payload.id ? { ...action.payload } : element
                    )
                }
            };
        default:
            return state;
    }
}